import { atom } from "@mongez/react-atom";
import { CommonLayout } from "../types";

export const commonLayoutAtom: any = atom<CommonLayout>({
  key: "commonLayout",
  default: {},
});
